import React, { useEffect, useRef, useState } from "react";

const MarketTicker: React.FC = () => {
  const container = useRef<HTMLDivElement>(null);
  const [hidden, setHidden] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.localStorage.getItem("tsm_market_ticker_hidden") === "1";
  });

  useEffect(() => {
    window.localStorage.setItem("tsm_market_ticker_hidden", hidden ? "1" : "0");
  }, [hidden]);

  useEffect(() => {
    if (hidden || !container.current) return;

    const existing = container.current.querySelector("script");
    if (existing) {
      existing.remove();
    }

    if (!container.current) return;

    const script = document.createElement("script");
    script.src = "https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js";
    script.type = "text/javascript";
    script.async = true;
    script.innerHTML = JSON.stringify({
      symbols: [
        { proName: "FOREXCOM:SPXUSD", title: "S&P 500" },
        { proName: "FRED:DJIA", title: "DJIA" },
        { proName: "TVC:GOLD", title: "Gold" },
        { proName: "TVC:USOIL", title: "US Oil" },
        { proName: "FX_IDC:EURUSD", title: "EUR/USD" },
        { proName: "COINBASE:BTCUSD", title: "BTC" },
        { proName: "COINBASE:ETHUSD", title: "ETH" },
        { proName: "COINBASE:SOLUSD", title: "SOL" },
        { proName: "COINBASE:XRPUSD", title: "XRP" },
        { proName: "COINBASE:DOGEUSD", title: "DOGE" },
        { proName: "COINBASE:BNBUSD", title: "BNB" },
      ],
      colorTheme: "dark",
      locale: "en",
      largeChartUrl: "",
      isTransparent: true,
      showSymbolLogo: true,
      displayMode: "compact",
    });

    container.current.appendChild(script);

    return () => {
      if (container.current) {
        const scripts = container.current.querySelectorAll("script");
        scripts.forEach((s) => s.remove());
      }
    };
  }, [hidden]);

  if (hidden) {
    return (
      <div className="market-ticker-wrapper market-ticker-wrapper--hidden" aria-label="Market ticker hidden">
        <div className="market-ticker-hidden">
          <span>Market tape hidden</span>
          <button
            type="button"
            className="market-ticker-action"
            onClick={() => setHidden(false)}
          >
            Show tape
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="market-ticker-wrapper" aria-label="Live market ticker">
      <div className="market-ticker-bar">
        <div className="market-ticker-container" ref={container} />
        <button
          type="button"
          className="market-ticker-action"
          onClick={() => setHidden(true)}
        >
          Hide tape
        </button>
      </div>
    </div>
  );
};

export default MarketTicker;
